import * as React from 'react'
import { FunctionComponent, PropsWithChildren } from 'react'
import { Label } from '@fluentui/react'

type Props = PropsWithChildren<{
    label: string
}>

const ActionHeaderFilter: FunctionComponent<Props> = props => (
    <div className="filter">
        <Label className="ms-Grid-col ms-sm12 ms-lg4">{props.label}</Label>
        <div className="ms-Grid-col ms-sm12 ms-lg8">
            {React.Children.map(props.children, (child: React.ReactElement) =>
                React.cloneElement(child, {
                    label: null,
                }),
            )}
        </div>
    </div>
)

export default ActionHeaderFilter
